import { ChevronDownIcon, ChevronUpIcon } from "@100mslive/react-icons";
import { Dropdown, Flex, Text } from "@100mslive/react-ui";
import { LANG_ARR, LANG_CODES_NAME } from "../../lang";
import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";

import { useDropdownSelection } from "../hooks/useDropdownSelection";
import { useTranslation } from "react-i18next";

const Language = () => {
  const { t, i18n } = useTranslation();
  const [selected, setSelectedLang] = useState(LANG_CODES_NAME.vi);
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const selectionBg = useDropdownSelection();

  const langLabel = useMemo(() => {
    const currentLang = LANG_ARR.find(lang => lang.code === selected);

    return currentLang?.label ? t(currentLang?.label) : "";
  }, [t, selected]);

  const handleChangeLang = langSelected => {
    setSelectedLang(langSelected);
    i18n.changeLanguage(langSelected);
    window.localStorage.setItem("lang", langSelected);
  };

  useEffect(() => {
    setSelectedLang(i18n.language);
  }, [t, i18n]);

  return (
    <Fragment>
      <Dropdown.Root open={open} onOpenChange={setOpen} css={{ width: "100%" }}>
        <Dropdown.Trigger
          asChild
          css={{
            border: "1px solid $borderLight",
            bg: "$surfaceLight",
            r: "$1",
            p: "$6 $9",
          }}
          ref={ref}
        >
          <Flex
            align="center"
            justify="between"
            css={{
              width: "160px",
              color: "white",
              padding: "8px !important",
              "@sm": { width: "140px", ml: 20, mt: 8 },
            }}
          >
            <Text
              css={{
                "@md": { fontSize: "$md" },
                "@sm": { fontSize: "$sm" },
              }}
            >
              {langLabel}
            </Text>
            {open ? (
              <ChevronUpIcon width={18} height={18} />
            ) : (
              <ChevronDownIcon width={18} height={18} />
            )}
          </Flex>
        </Dropdown.Trigger>
        <Dropdown.Portal>
          <Dropdown.Content
            align="start"
            sideOffset={8}
            css={{ zIndex: 1000, width: ref.current?.clientWidth, padding: 0 }}
          >
            {LANG_ARR.map(option => {
              return (
                <Dropdown.Item
                  key={option.value}
                  onSelect={() => handleChangeLang(option.code)}
                  css={{
                    px: "$9",
                    bg: selected === option.code ? selectionBg : undefined,
                    "@md": { fontSize: "$md" },
                    "@sm": { fontSize: "$sm" },
                  }}
                >
                  {t(option.label)}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Content>
        </Dropdown.Portal>
      </Dropdown.Root>
    </Fragment>
  );
};

export default Language;
